import { render, staticRenderFns } from "./MaterialsImportList.vue?vue&type=template&id=f08593a2&scoped=true&"
import script from "./MaterialsImportList.vue?vue&type=script&lang=js&"
export * from "./MaterialsImportList.vue?vue&type=script&lang=js&"
import style0 from "./MaterialsImportList.vue?vue&type=style&index=0&id=f08593a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08593a2",
  null
  
)

component.options.__file = "MaterialsImportList.vue"
export default component.exports